import { adapterModelSettingsUI } from '@/services/adapter/settings'

const moduleSettings = {
  state: {
    settings_ui: {
      font_size: 1,
      element_size: 1,
      line_size: 1,
    }
  },
  mutations: {
    SETTINGS_UI(state, data) {
      state.settings_ui = data
    },
    SETTINGS_UI_RESET(state) {
      state.settings_ui = {
        font_size: 1,
        element_size: 1,
        line_size: 1
      }
    }
  },
  actions: {},
  getters: {
    SETTINGS_UI: state => state.settings_ui,
    SETTINGS_ADAPTER_UI: state => adapterModelSettingsUI(state.settings_ui),
  }
}
export default moduleSettings